module.exports = __webpack_public_path__ + "static/img/fwfw_sshw.f247fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fwfw_sshw.jpg
// module id = al4z
// module chunks = 1